import React from 'react';
import useTranslation from '../../hooks/use-translation/use-translation';
import {useSelector} from 'react-redux';
import {selectProductData} from '../../../redux/reducers/productReducer';
import './product-attributes.scss';

const ProductAttributes = ({item, displayUnits, pdpExp}) => {
  const MAX_VISIBLE_CATEGORY_DEPTH = 99;
  const {freeShipping: hasFreeShipping} = useSelector(selectProductData);
  const {t} = useTranslation();
  const categoryUrl = item.categories.reduce(
    (a, x) => (x.depth > a.depth && x.depth < MAX_VISIBLE_CATEGORY_DEPTH ? x : a),
    {depth: -Infinity},
  ).relative_path;

  const artworkDimensions = () =>
    displayUnits ? item[`dimensions_text_${displayUnits}`] : item.dimensions_text_cm;

  return (
    <>
      {pdpExp !== 'urg' && hasFreeShipping && (
        <span className="badge badge-success badge-free-shipping">{t('Free shipping')}</span>
      )}

      <ul className="product-attributes">
        <li>
          <span>
            <a href={categoryUrl}>{item.category_full_name}</a> {t('on')} {item.substrate}
          </span>
        </li>
        {item.unique && (
          <li>
            <span>{t('One of a kind artwork')}</span>
          </li>
        )}
        {!item.unique && item.edition && item.edition > 0 && (
          <li>
            <span>
              {t('From a limited edition of')} {item.edition}
            </span>
          </li>
        )}
        <li>
          <span>
            {t('Size')}: {artworkDimensions()}
          </span>
        </li>
        {item.framed_text && (
          <li>
            <span>{item.framed_text}</span>
          </li>
        )}

        {item.signature_type_name && (
          <li>
            <span>{item.signature_type_name}</span>
          </li>
        )}

        {item.style_slug && (
          <li>
            <span>
              {t('Style')}: <a href={`/art/style-${item.style_slug}/`}>{item.style_name}</a>
            </span>
          </li>
        )}

        {item.subject_slug && (
          <li>
            <span>
              {t('Subject')}: <a href={`/art/subject-${item.subject_slug}/`}>{item.subject_name}</a>
            </span>
          </li>
        )}

        {!item.unique && item.quantity == 1 && (
          <li>
            <span>{t('Hurry only 1 left in stock')}</span>
          </li>
        )}

        {/* todo: I don't know how to achieve this.
        Are all the fields suppose to be part of the product object or some of them are part of the basket.
        Is the settings endpoint also involved? */}

        {/*
        {% if free_shipping_offer and not show_free_shipping_bubble %}
        {% get_basket_threshold_money free_shipping_offer as basket_threshold %}
        {% if basket_threshold %}
            <li>
                <strong>
                    {% blocktrans with basket_threshold=basket_threshold|prettify_money %}Free shipping on this artwork if you spend {{ basket_threshold }} or more{% endblocktrans %}
                </strong> - {% trans "Limited Time Offer" %}
            </li>
        {% else %}
            <li><strong>{% trans "Free Shipping" %}</strong> - {% trans "Limited Time Offer" %}</li>
        {% endif %}
    {% elif not free_shipping_offer %}
        {% if shipping_cost.amount == 0 and not show_free_shipping_bubble %}
            <li><strong>{% trans "Free Shipping" %}</strong></li>
        {% endif %}
    {% endif %}
        */}
      </ul>
    </>
  );
};

export default ProductAttributes;
